import { Component, OnInit } from '@angular/core';
import {IDialogView} from '@shared/components/ok-cancel-dialog/ok-cancel-dialog.component';
import {DialogModel} from '@shared/models/dialog.model';
import {SecurityState} from '@shared/store/reducers/security.reducer';
import {select, Store} from '@ngrx/store';
import {getUserInfo} from '@shared/store/selectors/security.selector';
import {Subject} from 'rxjs';
import {takeUntil} from 'rxjs/operators';

@Component({
    standalone: false,
    selector: 'particle-chat-settings-dialog',
  templateUrl: './chat-settings-dialog.component.html',
  styleUrls: ['./chat-settings-dialog.component.scss']
})
export class ChatSettingsDialogComponent implements OnInit, IDialogView {
  data: DialogModel;
  isGroupChat: boolean;
  private unsubscribe$ = new Subject<void>();
  chatTitle: string;
  currentUser: any;

  constructor(private securityStore: Store<SecurityState>) {
    this.chatTitle = '';
  }

  ngOnInit() {
    this.securityStore.pipe(select(getUserInfo)).pipe(takeUntil(this.unsubscribe$)).subscribe(currentUser => {
      this.currentUser = currentUser;
    });
    this.getChatSettings();
  }
  onChatSettingsChanged(isGroupChat) {
    if (this.isGroupChat) {
      this.chatTitle = '';
    } else {
      this.getOneToOneChatTitle();
    }
  }
  onOkClicked(): boolean {
    if (!this.chatTitle) { return false; }
    this.data.input.chatTitle = this.chatTitle;
    this.data.input.isGroupChat = this.isGroupChat;
    return true;
  }


  getChatSettings() {
    console.log(this.data.input);
    if (this.data.input.selectedUsers && this.data.input.selectedUsers.length === 2) {
      this.isGroupChat = false;
      this.getOneToOneChatTitle();
    } else {
      this.chatTitle = '';
      this.isGroupChat = true;
    }
  }

  getOneToOneChatTitle() {
    const otherUser = this.data.input.selectedUsers.filter(user => user.user.email !== this.currentUser.email);
    if (otherUser && otherUser.length) {
      this.chatTitle = `${otherUser[0].user.firstName} ${otherUser[0].user.lastName}`;
    }
  }
}
